import { api } from './client';
import type { ApiResponse } from '../types';

export interface PromptTemplateInput {
  title: string;
  description: string;
  about: string;
  category: string;
  tags: string[];
  prompt: string;
  skill?: string | null;
}
export interface SavedPromptTemplate extends PromptTemplateInput {
  id: number;
  share_token: string | null;
}
export type SharedPromptTemplate = PromptTemplateInput;

const path = (siteSlug: string) => `/v1/ai/templates?site_slug=${encodeURIComponent(siteSlug)}`;
const item = (siteSlug: string, id: number) => `/v1/ai/templates/${id}?site_slug=${encodeURIComponent(siteSlug)}`;
const share = (siteSlug: string, id: number) => `/v1/ai/templates/${id}/share?site_slug=${encodeURIComponent(siteSlug)}`;

export const promptTemplatesApi = {
  list: (siteSlug: string) => api.get<ApiResponse<SavedPromptTemplate[]>>(path(siteSlug)).then((r) => r.data ?? []),
  create: (siteSlug: string, data: PromptTemplateInput) => api.post<ApiResponse<SavedPromptTemplate>>(path(siteSlug), data).then((r) => r.data!),
  update: (siteSlug: string, id: number, data: PromptTemplateInput) => api.put<ApiResponse<SavedPromptTemplate>>(item(siteSlug, id), data).then((r) => r.data!),
  remove: (siteSlug: string, id: number) => api.delete<void>(item(siteSlug, id)),
  share: (siteSlug: string, id: number) => api.post<ApiResponse<SavedPromptTemplate>>(share(siteSlug, id), {}).then((r) => r.data!),
  revoke: (siteSlug: string, id: number) => api.delete<ApiResponse<SavedPromptTemplate>>(share(siteSlug, id)).then((r) => r.data!),
  readShared: (token: string) => api.get<ApiResponse<SharedPromptTemplate>>(`/v1/ai/templates/shared/${encodeURIComponent(token)}`, { auth: 'none' }).then((r) => r.data!),
};
